<template>
  <div class="orderAll">
    <!-- 订单雷达页面头部筛选 -->
    <div>
      <orderHead @searchWord="searchWord" ref="orderHead"></orderHead>
    </div>
    <div class="searchSizer" :key="searchSizerKey">
      <!-- 筛选条件 -->
      <areaList :countryList="selectObj.countryList" :selectList="condition ? condition.areaList : null"/>
      <CateGory :subCategoryList="selectObj.subCategoryList" :selectList="condition ? condition.subCategoryList : null"/>
      <Material :materialList="selectObj.materialList" :selectList="condition ? condition.materialList : null"/>
      <partSize :partSizeType="selectObj.partSizeType" :selectList="condition ? condition.sizeTypeList : null"/>
      <payWay :payment="selectObj.payment" :selectList="condition ? condition.paymentTermsList : null"/>
      <orderSource :rfqSource="selectObj.rfqSource" :selectList="condition ? condition.clientSourceList : null"/>
      <div class="clear" @click="clear">清空</div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import orderHead from "@/components/zhenyunOrder/head"
import CateGory from "@/components/zhenyunOrder/searchSizer/category"
import Material from '@/components/zhenyunOrder/searchSizer/material';
import partSize from '@/components/zhenyunOrder/searchSizer/partSize';
import payWay from '@/components/zhenyunOrder/searchSizer/payWay';
import orderSource from '@/components/zhenyunOrder/searchSizer/orderSource';
import areaList from '@/components/zhenyunOrder/searchSizer/area';

import {getadvanceoption,initSearchCondition} from "@/utils/api/zhenyunOrder"
import { getDictByType } from '@/utils/api/common.js'
import zhenyunOrderMinxis from "@/mixins/zhenyunOrder.js";
export default {
  mixins: [zhenyunOrderMinxis],
  name: 'ComponentName',
  components: {
    orderHead,CateGory,Material,partSize,orderSource,payWay,areaList
  },
  props: [],
  data() {
    return {
      //
      selectObj: {
        subCategoryList: null,
        materialList: null,
        countryList: null,
        partSizeType:null,
        rfqSource:null,
        payment:null,
      },
      condition: null,
      keyword:'',
      searchSizerKey:new Date().getTime()
    };
  },
  methods: {
    //
    async initData() {
      try {
        const res = await initSearchCondition()
        if (res.rspResult.bizCode === 200) {
          this.selectObj = res.data
          this.selectObj.subCategoryList = res.data.categoryList
          this.selectObj.materialList = res.data.material
          this.selectObj.countryList.forEach((row, index) => {
            if (row.codeValue === "247"||row.codeValue==247) {
              //中国
              this.selectObj.countryList.splice(index, 1);
              this.selectObj.countryList.unshift(row);
            }
          });
        }
      } catch (err) {
        console.error("❌ ~ file: index.vue:381 ~ initData ~ err:", err)
      }
    },
    clear(){
      if(this.keyword){
        this.$router.replace({path: this.$route.path,query:{
         keyword: this.keyword
        }})
      }else{
        this.$router.replace({path: this.$route.path})
      }
      this.condition=this.getParams(1)
      this.$refs.orderHead.keyword=this.condition.keyword
      this.searchSizerKey=+new Date().getTime()
    },
    searchWord(val){
      this.keyword=val
      let obj = { ...this.$route.query};
      if(val) {
        obj.keyword = this.keyword
      } else {
        delete obj.keyword;
      }
      this.$router.push({
        path: this.$route.path,
        query:obj
      })
    }
  },
  mounted() {
  },
  created(){
    this.initData()
    this.condition=this.getParams(1)
    // this.$nextTick(()=>{
    //   this.$refs.orderHead.keyword=this.condition.keyword
    // })
    
  },
  watch:{
    '$route.query':{
      handler(val){
        // this.condition=this.getParams(1)
        this.$nextTick(()=>{
          this.$refs.orderHead.keyword=val.keyword
        })
        
      },
      immediate:true
    }
  }
};
</script>

<style lang="scss" scoped>
/* SCSS or CSS here */
.orderAll{
  background: #F5F7FA;
  font-family: 'SourceHanSansCN-Regular';
}
.searchSizer{
  display: flex;
  height: 62px;
  align-items: center;
  padding:0 24px;
  position: sticky;
  top: 84px;
  background: #F5F7FA;
  z-index: 6;
  .clear{
    margin-left: auto;
    color: #222222;
    font-size: 14px;
    cursor: pointer;
  }
}
</style>